export default __webpack_public_path__ + "static/consul-service-mesh-3a4041df0c7c4e873779577c705c7876.webp";